export default __webpack_public_path__ + "static/media/tactic-instagram.5acb42cc.svg";